import { render, staticRenderFns } from "./recordInboundAndOutbound.vue?vue&type=template&id=bbb3e3a2&"
import script from "./recordInboundAndOutbound.vue?vue&type=script&lang=js&"
export * from "./recordInboundAndOutbound.vue?vue&type=script&lang=js&"
import style0 from "./recordInboundAndOutbound.vue?vue&type=style&index=0&id=bbb3e3a2&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports